import i18n from '@/i18n';

export type FormItemWithClass<T> = {
    id: string | number | null;
    name: string | null;
    value: T;
};

export type FormItem = FormItemWithClass<unknown>;

export type MultiCheckboxFilterItem = {
    value: number;
    name: string;
    color?: string;
};

export function createFromEnum<E>(
    type: Record<string, unknown>,
    prefix: string,
): FormItemWithClass<E>[] {
    return Object.keys(type).map((item, index) => {
        return {
            id: index + 1,
            name: i18n.t(`${prefix}${item}`).toString(),
            value: type[item as keyof typeof type] as E,
        };
    });
}

export function createFromEnumWithOptional<E>(
    type: Record<string, unknown>,
    prefix: string,
): FormItemWithClass<E | null>[] {
    const result = new Array<FormItemWithClass<E | null>>();
    result.push({ id: 0, name: '', value: null });
    createFromEnum<E | null>(type, prefix).forEach((item) => result.push(item));

    return result;
}
